import { render, staticRenderFns } from "./LicenciasCliente.vue?vue&type=template&id=4cc2836e&scoped=true"
import script from "./LicenciasCliente.vue?vue&type=script&lang=js"
export * from "./LicenciasCliente.vue?vue&type=script&lang=js"
import style0 from "./LicenciasCliente.vue?vue&type=style&index=0&id=4cc2836e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc2836e",
  null
  
)

export default component.exports